import localForage from 'localforage';

const audioCaches = localForage.createInstance({
  name: 'audio-cache',
});

export const cacheAudioUrl = async (url) => {
  let audioType = 'audio/mpeg';

  if ((url || '').includes('wav')) {
    audioType = 'audio/wav';
  }

  const res =
    (await audioCaches.getItem(url)) ||
    (await fetch(url).then((response) => {
      audioCaches.setItem(url, response.clone().arrayBuffer());
      return response.clone().arrayBuffer();
    }));

  return responseToAudioUrl(res, audioType);
};

export const cacheAudioUrlWithProgress = async (url, onProgress) => {
  const isExist = await audioCaches.getItem(url);
  if (isExist) {
    onProgress(100);
    return responseToAudioUrl(isExist);
  }

  const response = await fetch(url);
  const contentLength = response.headers.get('content-length');
  const totalBytes = parseInt(contentLength, 10);
  let loadedBytes = 0;
  const reader = response.body.getReader();
  const chunks = [];

  // eslint-disable-next-line no-constant-condition
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;

    chunks.push(value);
    loadedBytes += value.length;
    const progress = (loadedBytes / totalBytes) * 100;

    onProgress(progress);
  }
  onProgress(100);
  const blob = new Blob(chunks);
  const clonedResponse = await new Response(blob, response).arrayBuffer();
  audioCaches.setItem(url, clonedResponse);
  return responseToAudioUrl(clonedResponse);
};

const responseToAudioUrl = async (response, audioType = 'audio/mpeg') => {
  const blob = new Blob([response], { type: audioType });
  return URL.createObjectURL(blob);
};
